<template>
    <div class="relative">
        <CCard>
            <CCardHeader>
                <p>Настройки страницы оплаты</p>
            </CCardHeader>
            <CCardBody v-if="model">
                <template v-for="(payment, index) in payments_list">
                    <div :key="index" class="flex py-2">
                        <div class="w-1/4 font-medium">{{ payment.title }}</div>
                        <div class="w-3/4">
                            <CSwitch
                                :checked.sync="model.settings.payments[payment.value]"
                                color="success"
                                shape="pill"
                            />
                        </div>
                    </div>
                </template>
                <div class="flex py-2">
                    <div class="w-1/4 font-medium">Текст на странице</div>
                    <div class="w-3/4">
                        <CTextarea
                            v-model="model.settings.text"
                            :rows="5"
                            horizontal
                        />
                    </div>
                </div>
            </CCardBody>

            <CCardFooter>
                <CButton
                    class="ml-auto"
                    color="primary"
                    @click="submit">
                    Сохранить
                </CButton>
            </CCardFooter>
        </CCard>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
    </div>
</template>

<script>
    import { cilSettings } from '@coreui/icons';

    export default {
        icons: {
            cilSettings
        },

        data: () => ({
            isPending: false,
            model: {
                id: 0,
                page: 'payment',
                settings: {
                    text: '',
                    payments: {
                        applepay: true,
                        googlepay: true,
                        cards: true,
                        sbp: true,
                    }
                }
            },
            payments_list: [
                {
                    title: 'Apple pay',
                    value: 'applepay',
                    active: true,
                },
                {
                    title: 'Google pay',
                    value: 'googlepay',
                    active: true,
                },
                {
                    title: 'Карты',
                    value: 'cards',
                    active: true,
                },
                {
                    title: 'СБП',
                    value: 'sbp',
                    active: true,
                },
            ]
        }),

        computed: {
        },

        watch: {
            // model: {
            //     deep: true,
            //     handler() {
            //         let list = [...this.model.settings.services_list];

            //         list = list
            //             .map((item, index) => {
            //                 if (!item) {
            //                     return item;
            //                 }

            //                 if (item.horizontal) {
            //                     return item;
            //                 }

            //                 if (item && !item.horizontal && list[index + 1] && !list[index + 1].horizontal) {
            //                     const group = [ item, { ...list[index + 1] } ];
            //                     list[index + 1] = null;
            //                     return group;
            //                 }

            //                 return [ item ];
            //             })
            //             .filter(item => !!item);
            
            //         this.servicesList = list;
            //     }
            // }
        },

        async created() {
            await this.fetchEntity();
        },

        methods: {
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },

            async fetchEntity() {
                try {
                    this.isPending = true
                    const { data } = await this.axios.get('/page-settings/payment');
                    if (data && data.settings) {
                        this.model = data;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            async submit() {
                try {
                    this.isPending = true
                    const { id, ...data } = this.model;
                    if (id) {
                        await this.axios.put(`/page-settings/${id}`, data)
                    } else {
                        await this.axios.post('/page-settings', data)
                    }
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },
        }
    }
</script>

<style lang="scss">
.Tile {
    max-height: 568px;
    overflow-y: auto;
  @apply flex flex-col h-full p-2 border rounded-md cursor-pointer;

  &:hover {
    @apply shadow-md;
  }

  &.--selected {
    box-shadow: 0 0 1px 1px rgba(66, 153, 225, 1);
  }

  &__container {
    @apply flex flex-1 justify-between gap-2;
    height: auto;
    display: block;
    margin-bottom: 8px;
    .Tile__container > .Tile__container {
        margin-bottom: 0;
    }
    &:last-child {
        margin-bottom: 0;
    }
    & div {
        @apply flex flex-1 justify-center gap-2;

        overflow: hidden;
        position: relative;

        strong {
            position: absolute;
            top: 10px;
            left: 10px;
        }
    }

    &.--vertical {
      @apply flex-col;
    }
  }

  &__item {
    @apply flex justify-center items-center flex-1 bg-gray-300 rounded-md text-xs;
    text-align: center;
  }
}

.phone__container {
    width: 100%;
    max-width: 320px;
}
</style>